export default "__VITE_ASSET__BCoKo1Oz__"